export default __webpack_public_path__ + "static/media/icon-hands-raised.e7ad68f4.svg";